import React from 'react';
import { BsBuilding, BsCloudUpload, BsEnvelope, BsPeople } from 'react-icons/bs';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { Box, Flex, VStack } from '@chakra-ui/react';

import NavBarLink from '../../components/NavBar/NavBarLink';
import { selectNavExpanded } from '../../redux/modules/navbar';
import { getContentHeightString, Nav } from '../../styles/layoutDimensions';
import colors from '../../styles/theme/foundation/colors';

const PinsAdminNavBar = () => {
  const isNavExpanded = useSelector(selectNavExpanded);
  const { pathname } = useLocation();

  const navWidth = isNavExpanded ? Nav.expandedWidth : Nav.collapsedWidth;
  const navLinkStyle = isNavExpanded ? 'expanded' : 'collapsed';

  const getVariant = path => {
    if (path === '/pinsadmin/companies' && (pathname === '/pinsadmin' || pathname === '/pinsadmin/')) {
      return 'accent';
    }

    return pathname.startsWith(path) ? 'accent' : 'textGrey';
  };

  return (
    <Box
      bg="white"
      display="flex"
      flexDirection="column"
      minW={navWidth}
      sx={{ minH: getContentHeightString() }}
      zIndex="500"
    >
      <Flex
        alignItems="center"
        bg="white"
        boxShadow={`inset 0 1px ${colors.greyScale['200']}`}
        color="greyScale.700"
        flexDirection="column"
        height={getContentHeightString()}
        justifyContent="flex-start"
        left={0}
        position="fixed"
        pt={8}
        width={navWidth}
      >
        <VStack justifyContent="center" spacing={6}>
          <NavBarLink
            icon={BsBuilding}
            style={navLinkStyle}
            title="Companies"
            to="/pinsadmin/companies"
            variant={getVariant('/pinsadmin/companies')}
          />
          <NavBarLink
            icon={BsPeople}
            style={navLinkStyle}
            title="Users"
            to="/pinsadmin/users"
            variant={getVariant('/pinsadmin/users')}
          />
          <NavBarLink
            icon={BsEnvelope}
            style={navLinkStyle}
            title="Email Logs"
            to="/pinsadmin/email-logs"
            variant={getVariant('/pinsadmin/email-logs')}
          />
          <NavBarLink
            icon={BsCloudUpload}
            style={navLinkStyle}
            title="Imports"
            to="/pinsadmin/imports"
            variant={getVariant('/pinsadmin/imports')}
          />
        </VStack>
      </Flex>
    </Box>
  );
};

export default PinsAdminNavBar;
